import React , { useEffect , useState }from 'react'

//import MoveTable from './MoveTheTable'
import MoveTheTableRep from './MoveTheTableRep'
import MoveScroller from './MoveScroller'

import { ApiCallGet } from '../ApiCall/ApiCall'
import MoveButton from './MoveButton'

function Index2() {

const [response,setResponse] = useState( null )

// Consulta de datos repetidos
// select numtel,  count(numtel) c , ... from demo group by nombre having c >1

useEffect(() => {
    //backMonitor()
    ApiCallGet( 'downfilerep?first=' + 1 +"&len=" + 20)
    .then( (response) => {
        console.log( "Nos esta llegando la respuesta")
        //console.log(  )
        setResponse( response )
    } )
    .catch( (error) => {
        console.log( error )
    })
},[])

  return (
    <div>
        <MoveTheTableRep data={response}/>
        <MoveScroller/>
        {/* <MoveButton/> */}
    </div>
  )
}

export default Index2